<template>
  <div 
    v-if="similarProducts.length || sameFormatProducts.length || sameIngredientProducts.length"
    class="product-listings-tabs">
    <ul class="product-listings-tabs__ul">
      <li 
        v-if="similarProducts.length"
        :class="{ 'isActive': activeTab === 'similar' }"
        @click="$_tabClick('similar')">
          {{ $t('tabs.similarProducts') }}
      </li>
      <li
        v-if="sameFormatProducts.length"
        :class="{ 'isActive': activeTab === 'format' }" 
        @click="$_tabClick('format')">
          {{ $t('tabs.formatProducts') }}
      </li>
      <li
        v-if="sameIngredientProducts.length"
        :class="{ 'isActive': activeTab === 'ingredient' }" 
        @click="$_tabClick('ingredient')">
          {{ $t('tabs.sameIngredientProducts') }}
      </li>
    </ul>
    <SwiperTab v-show="similarProducts.length && activeTab === 'similar'" :list="similarProducts" :activeTab="activeTab"/>
    <SwiperTab v-show="sameFormatProducts.length && activeTab === 'format'" :list="sameFormatProducts" :activeTab="activeTab"/>
    <SwiperTab v-show="sameIngredientProducts.length && activeTab === 'ingredient'" :list="sameIngredientProducts" :activeTab="activeTab"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SwiperTab from '@/components/SwiperTab/SwiperTab.vue'

export default {
  name: 'ProductListingsTabs',
  components: {
    SwiperTab
  },
  data: () => ({
    loading: true,
    settedTab: undefined
  }),
  props: {
    slug: {
      type: String,
      required: true
    },
    shownProducts: {
      type: Number,
      default: () => 8
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'products',
      'product',
      'categories',
      'tagsParents'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    activeTab: {
      get () {
        if (this.settedTab !== undefined) return this.settedTab
        if (this.similarProducts.length) return 'similar'
        if (this.sameFormatProducts.length) return 'format'
        if (this.sameIngredientProducts.length) return 'ingredient'
      }
    },
    similarProducts: {
      get () {
        if (this.loading) return []
        if (typeof this.currentProduct.fields.category === 'undefined') return []
        return this.products
          .filter(productElement => typeof productElement.fields.category !== 'undefined')
          .filter(productElement => this.currentProduct.fields.category.fields.slug === productElement.fields.category.fields.slug)
          .filter(productElement => this.currentProduct.fields.slug !== productElement.fields.slug)
          .slice(0, this.shownProducts - 1)
      }
    },
    sameFormatProducts: {
      get () {
        if (this.loading) return []
        if (typeof this.currentProduct.fields.tags === 'undefined') return []
        const currentTag = this.currentProduct.fields.tags.find(tag => {
          if (typeof tag.fields.parentGroup !== 'undefined' && tag.fields.parentGroup.sys.id === '5assMyDAkwCOg2YiOQ8SwM') return tag
        })
        if (currentTag === undefined) return []
        // console.log('currentFormat', currentTag)
        return this.getSimilarEntries(currentTag)
        return []
      }
    },
    sameIngredientProducts: {
      get () {
        if (this.loading) return []
        if (typeof this.currentProduct.fields.tags === 'undefined') return []
        const currentTag = this.currentProduct.fields.tags.find(tag => {
          if (typeof tag.fields.parentGroup !== 'undefined' && tag.fields.parentGroup.sys.id === '4F9dG7csPememGc4OqCEeC') return tag
        })
        if (currentTag === undefined) return []
        // console.log('currentIngredient', currentTag)
        return this.getSimilarEntries(currentTag)
        return []
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts',
      'loadCategories',
      'loadTagsParents'
    ]),
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadProducts(), this.loadCategories(), this.loadTagsParents()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    getSimilarEntries (searchTag) {
      // get tag of the current product filtering by parentId. If not, return an empty array.
      return this.products
        .filter(productElement => typeof productElement.fields !== 'undefined')
        .filter(productElement => typeof productElement.fields.tags !== 'undefined')
        .filter(productElement => {
          const exist = productElement.fields.tags.find(tag => {
            return tag.fields.slug === searchTag.fields.slug
          })
          return exist !== undefined
        })
        .filter(productElement => this.currentProduct.fields.slug !== productElement.fields.slug)
        .slice(0, this.shownProducts - 1)
    },
    $_tabClick (tab) {
      this.settedTab = tab
    }
  }
}
</script>

<style lang="scss">
  @import "./tabs.scss";
</style>
